var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-page',[_c('div',{staticClass:"ticket-template-empty"},[_c('app-state-overlay',{attrs:{"state":"empty","title":"Diese Seite ist noch leer.","offset-top":0}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }